import { Box, Button, Grid, TextField, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";

export const RetailView: React.FC<any> = React.memo(() => {
  const [input, setInput] = useState("");

  const handleKeyPress = (key: string) => {
    setInput((prev) => prev + key);
  };

  const handleBackspace = () => {
    setInput((prev) => prev.slice(0, -1));
  };

  const handleEnter = () => {
    setInput((prev) => prev + "\n");
  };

  // Keys organized by rows
  const keysRow1 = ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"];
  const keysRow2 = ["a", "s", "d", "f", "g", "h", "j", "k", "l"];
  const keysRow3 = ["⇧", "z", "x", "c", "v", "b", "n", "m", "⌫"];
  const keysRow4 = ["?123", ",", "a-z", " ", ".", "⏎"];

  return (
    <Grid
      xs={12}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bgcolor="#f0f0f0"
    >
      {/* Total and Amount Display */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        maxWidth={800}
        p={1}
        bgcolor="#ffffff"
        borderRadius={1}
        border="1px solid #d3d3d3"
        mb={2}
      >
        <Typography variant="h6" color="textSecondary">
          Total
        </Typography>
        <Typography variant="h6" color="textPrimary">
          0.00
        </Typography>
      </Box>

      {/* Text Area */}
      <TextField
        value={input}
        onChange={(e) => setInput(e.target.value)}
        variant="outlined"
        fullWidth
        multiline
        rows={1}
        placeholder=""
        sx={{
          width: "100%",
          maxWidth: 800,
          mb: 2,
          backgroundColor: "#e0e0e0",
          "& .MuiOutlinedInput-root": {
            borderRadius: 0,
          },
        }}
      />

      {/* Keyboard Container */}
      <Box
        sx={{
          maxWidth: 800,
          width: "100%",
          backgroundColor: "#ffffff",
          borderRadius: 1,
          border: "1px solid #d3d3d3",
          p: 1,
        }}
      >
        {/* First Row */}
        <Grid container spacing={0.5} justifyContent="center">
          {keysRow1.map((key) => (
            <Grid item xs={1} key={key}> {/* Reduced width here */}
              <Button
                onClick={() => handleKeyPress(key)}
                variant="outlined"
                fullWidth
                sx={{
                  minWidth: 0,
                  padding: "5px 0", // Reduced padding
                  color: "#333",
                  backgroundColor: "#fff",
                  borderColor: "#ccc",
                  fontSize: "0.8rem", // Reduced font size
                }}
              >
                {key}
              </Button>
            </Grid>
          ))}
        </Grid>

        {/* Second Row */}
        <Grid container spacing={0.5} justifyContent="center" sx={{ mt: 1 }}>
          {keysRow2.map((key) => (
            <Grid item xs={1} key={key}> {/* Reduced width here */}
              <Button
                onClick={() => handleKeyPress(key)}
                variant="outlined"
                fullWidth
                sx={{
                  minWidth: 0,
                  padding: "5px 0", // Reduced padding
                  color: "#333",
                  backgroundColor: "#fff",
                  borderColor: "#ccc",
                  fontSize: "0.8rem", // Reduced font size
                }}
              >
                {key}
              </Button>
            </Grid>
          ))}
        </Grid>

        {/* Third Row */}
        <Grid container spacing={0.5} justifyContent="center" sx={{ mt: 1 }}>
          {keysRow3.map((key) => (
            <Grid item xs={key === "⌫" ? 2.4 : 1} key={key}> {/* Adjusted width for backspace key */}
              {key === "⌫" ? (
                <IconButton
                  onClick={handleBackspace}
                  sx={{
                    width: "100%",
                    backgroundColor: "#fff",
                    borderColor: "#ccc",
                    borderRadius: 1,
                  }}
                >
                  <WSIcons.BackspaceIcon fontSize="small" />
                </IconButton>
              ) : (
                <Button
                  onClick={() => handleKeyPress(key)}
                  variant="outlined"
                  fullWidth
                  sx={{
                    minWidth: 0,
                    padding: "5px 0", // Reduced padding
                    color: "#333",
                    backgroundColor: "#fff",
                    borderColor: "#ccc",
                    fontSize: "0.8rem", // Reduced font size
                  }}
                >
                  {key}
                </Button>
              )}
            </Grid>
          ))}
        </Grid>

        {/* Fourth Row */}
        <Grid container spacing={0.5} justifyContent="center" sx={{ mt: 1 }}>
          {keysRow4.map((key) => (
            <Grid item xs={key === " " ? 4.8 : 1} key={key}> {/* Adjusted width for space key */}
              {key === "⏎" ? (
                <Button
                  onClick={handleEnter}
                  variant="outlined"
                  fullWidth
                  sx={{
                    minWidth: 0,
                    padding: "5px 0", // Reduced padding
                    color: "#333",
                    backgroundColor: "#fff",
                    borderColor: "#ccc",
                    fontSize: "0.8rem", // Reduced font size
                  }}
                >
                  {key}
                </Button>
              ) : (
                <Button
                  onClick={() => handleKeyPress(key)}
                  variant="outlined"
                  fullWidth
                  sx={{
                    minWidth: 0,
                    padding: "5px 0", // Reduced padding
                    color: "#333",
                    backgroundColor: "#fff",
                    borderColor: "#ccc",
                    fontSize: "0.8rem", // Reduced font size
                  }}
                >
                  {key === " " ? "Space" : key}
                </Button>
              )}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Grid>
  );
});
